import { createStore, combineReducers } from 'redux'
import auth from './reducers/auth'
import avatarImage from './reducers/avatarImage'
import {
  setClientsListLastUpdatedAt as clientLastUpdatedAtEvent,
  setUsersListLastUpdatedAt as userLastUpdatedAtEvent
} from './reducers/lastUpdatedAtEvent'

const rootReducer = combineReducers({
  auth,
  avatarImage,
  clientLastUpdatedAtEvent,
  userLastUpdatedAtEvent
})

const store = createStore(rootReducer)

export default store
